import { Component } from '@angular/core';
import { NotificationData, PaginationInfo } from '../../notification-list/notification-list.component';

@Component({
  selector: 'app-notification-list-showcase',
  templateUrl: './notification-list-showcase.component.html',
  styleUrls: ['./notification-list-showcase.component.scss']
})
export class NotificationListShowcaseComponent {
  isLoading = false;

  // Sample data with pagination
  allNotifications: NotificationData[] = [
    { id: 82862, message: 'Learn what you can do as a Partner Leader in Seller Rewards. <a href="https://sellerrewards.cisco.com" target="_blank">Click here</a>', viewed: true, category: 'WELCOME_LEADER' },
    { id: 260693, message: '50000 challenge has been completed. Check out challenges.', viewed: true, category: 'CHALLENGE_COMPLETED' },
    { id: 260470, message: '1000 challenge has been completed. Check out challenges.', viewed: false, category: 'CHALLENGE_COMPLETED' },
    { id: 260447, message: 'Your company has assigned you a new Challenge to earn Seller Rewards tickets. Get started now.', viewed: true, category: 'NEW_CHALLENGE' },
    { id: 260370, message: 'You have been assigned the designated Administrator role by your company administrator.', viewed: false, category: 'ROLE_ASSIGNMENT' },
    { id: 260369, message: 'New partnership opportunity available for your region.', viewed: true, category: 'WELCOME_LEADER' },
    { id: 260368, message: 'Quarterly sales target has been updated.', viewed: true, category: 'NEW_CHALLENGE' },
    { id: 260367, message: 'Team challenge completed successfully!', viewed: false, category: 'CHALLENGE_COMPLETED' },
    { id: 260366, message: 'You are now eligible for premium rewards.', viewed: true, category: 'ROLE_ASSIGNMENT' },
    { id: 260365, message: 'New training materials have been published.', viewed: false, category: 'WELCOME_LEADER' }
  ];

  pageSize = 5;
  currentPage = 0;
  notificationsForPage: NotificationData[] = [];
  currentPagination: PaginationInfo;
  removedNotifications = new Set<number>();

  constructor() {
    this.updatePage();
  }

  private updatePage(): void {
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.notificationsForPage = this.allNotifications.slice(start, end);

    this.currentPagination = {
      pageSize: this.pageSize,
      pageNumber: this.currentPage,
      totalElements: this.allNotifications.length,
      totalPages: Math.ceil(this.allNotifications.length / this.pageSize),
      first: this.currentPage === 0,
      last: this.currentPage === Math.ceil(this.allNotifications.length / this.pageSize) - 1
    };
  }

  onPageChange(pageNumber: number): void {
    this.currentPage = pageNumber;
    this.updatePage();
  }

  onRemoveNotification(id: number): void {
    this.removedNotifications.add(id);
    this.notificationsForPage = this.notificationsForPage.filter(n => n.id !== id);
  }

  simulateLoading(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  }

  resetPage(): void {
    this.currentPage = 0;
    this.removedNotifications.clear();
    this.allNotifications = this.allNotifications.filter(n => !this.removedNotifications.has(n.id));
    this.updatePage();
  }
}
